import React, { useState, useEffect } from 'react'

export function ManagerFeedback(props) {

    useEffect(() => {

    })

    const bindmanagerInfo = () => {
        return (
            <>
                <textarea maxLength={3000} onChange={(e) => { props.onSubmit({ managerFeedback: e.target.value, managerId: props.Details.roleId }, props.Details.role) }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={props.ManagerFeedback} />
                <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p>
            </>
            // <>{props.ManagerFeedback ?
            //     <> <textarea maxLength={3000} onChange={(e) => { props.onSubmit({managerFeedback: e.target.value, managerId: props.Details.roleId }, "Manager") }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={props.ManagerFeedback} />
            //         <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p> </> :
            //     <>
            //     <textarea maxLength={3000} onChange={(e) => { props.onSubmit({managerFeedback: e.target.value, managerId: props.Details.roleId }, "Manager") }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={""} />
            //     <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p> 
            //     </>}
            // </>
        )
    }

    const bindempInfo = () => {
        return (
            <>{props.ManagerFeedback !== undefined ?
                <> <p className="font-12 medium-text touchbase-feedback-text">{props.ManagerFeedback}</p>
                    <p className="text-end mt-2 font-12 medium-text touchbase-submitted-color">Submitted by {props.ManagerFeedbackBy}</p> </> :
                <><textarea className="form-control hive-form-control touchbase-comments" id="teammember-feedback" disabled placeholder="Enter Here" rows={3} defaultValue={props.ManagerFeedback} /></>}
            </>
        )
    }

    return (
        <>
            {((props.Details.role === 'Manager' )&& props?.status != 'Completed') ? bindmanagerInfo() : bindempInfo()}
        </>
    )
}
